<template>
  <div class="main">
      <div class="nav">
        <van-nav-bar
        title="可选套餐"
        left-arrow
        :fixed=true
        @click-left="onClickLeft"
      />
      <div class="top">

      </div>
      </div>
        <van-notice-bar
  left-icon="info-o"
  color="#1989fa"
  background="#ecf9ff"
  :scrollable="true"
  text="点击可查看体检套餐项目明细,展示价格与医院价格有出入,最终价格以医院为主"
/>
        <div
          class="paycard"
          v-for="(item, index) in pelistinfo"
          :key="index"
          @click="getpedetail(item)"
        >
          <div>
            <div class="Crow">
              <div>套餐名称</div>
              <div>{{item.packageName}}</div>
            </div>
            <div class="Crow">
              <div>价格</div>
              <div v-if="item.factprice">￥:{{item.factprice}}</div>
              <div v-else>暂无参考价格</div>
            </div>
           
          </div>
        </div>
      
  </div>
</template>

<script>
import Nav from '../../components/nav.vue'
export default {
  components:{
      Nav
  },
  data() {
    return {
      show:false,
      busiType:"",
      peisType:"",
      gender:"",
      pelistinfo:"",
    }
  },
  mounted(){
    if(this.$route.query.info){
       this.peisType=this.$local.get("form").TJLX;
      this.busiType=this.$local.get("form").petype;
      this.gender=this.$local.get("form").genderId;
    }
    this.getpelist()
  },
  methods:{
     onClickLeft(){
       this.$router.push('/index');
      },
     async getpelist(){
         try {
        this.$showLoad()
        let url = '/peisprecontroller/querypackage'
        let R_data = {
         busiType:this.busiType,
         peisType:this.peisType,
         gender:this.gender
        };
       await this.$axios_request.request_data("nodeserver", url, "post", R_data,(data)=>{
         console.log(data.data)
         this.pelistinfo=data.data.data.data
         console.log( this.pelistinfo)

      this.$hideLoad()
       });
      } catch (error) {
        this.isLoad = false
        this.$hideLoad()
        this.$toast.fail('网络连接失败');
      }
    },
     getpedetail(item){
      console.log(item)
      let packageName=item.packageName;
      let packageCode=item.packageCode;
       this.$router.push({
            path: "/pe_meal_detali",
            query: {
              name:packageName,
              packageId:packageCode
            },
        });
    },
  },
}
</script>

<style lang="scss" scoped>
.main{
    padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
   .top{
  height: 50px;
}
    .paycard {
    padding: 5px;
    width: 95%;
    display: flex;
    flex-direction: column;
    // border: 1px solid #5b8df6;
    border-radius: 8px;
    margin: 0px auto;
    margin-top: 5px;
    margin-bottom: 10px;
    box-shadow: 0 1px 3px #5b8df6;
  }
  .head {
    margin-left: 10px;
    margin-right: 10px;
    color: #5b8df6;
    display: flex;
    justify-content: center;
    border-bottom: 1px dashed #5b8df6;
    font-size: 16px;
    line-height: 30px;
    .checkbox {
      margin-top: 5px;
    }
  }
  .content {
    width: 90%;
    display: flex;
    flex-direction: column;
    border: 1px solid #95a5a6;
    border-radius: 15px;
    margin: 0px auto;
  }
  .Crow {
    color: #747d8c;
    margin-left: 20px;
    margin-right: 20px;
    line-height: 30px;
    display: flex;
    font-size: 15px;
    justify-content: space-between;
    .gold {
      color: #e74c3c;
    }
    .green {
      color: #2ed573;
    }
  }
 
}
</style>